import { TransitionEvent } from 'react';

type TransitionEndHandlerOptions = {
  onVisible?: () => void;
  delay?: number;
};

const createTransitionEndHandler =
  ({ onVisible, delay = 1000 }: TransitionEndHandlerOptions = {}) =>
  (e: TransitionEvent<HTMLElement>) => {
    if (e.propertyName === 'opacity') {
      const target = e.currentTarget;
      if (!target || !(target instanceof Element)) {
        return;
      }

      setTimeout(() => {
        try {
          const style = window.getComputedStyle(target);
          const isVisible = style.visibility === 'visible' && style.opacity === '1';

          if (isVisible && onVisible) {
            onVisible();
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn('Error getting computed style:', error);
        }
      }, delay);
    }
  };

export default createTransitionEndHandler;
